import router from 'next/router';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { isMobile as isMobileDetect } from 'react-device-detect';
import { apenasNumeros, formatSelects } from '../../utils/FunctionsGlobals';
import {
  getMarketingConsentFromDocument,
  getMarketingConsentFromLocalStorage,
  resolveMarketingConsentState,
  writeMarketingConsentCookie,
  writeMarketingConsentLocalStorage,
} from '../../utils/marketingConsent';
import {
  clearLegacyHomeStorageKeys,
  getAllDataHomeStorageKey,
  getHomeScopedStorageKey,
  getImoveisLastSearchUrlStorageKey,
  readJsonStorageValue,
  setJsonStorageValue,
} from '../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../utils/storage';

/*
 * ---------------------------------------------------------------
 * TIPAGEM
 * ---------------------------------------------------------------
 */

interface AuthData {
  site: {
    fb_token_pixel: string;
    top_10: boolean;
    redes_topo: boolean;
    internacional: boolean;
    fb_id_pixel: string;
    ocultar_endereco: boolean;
    copyright: boolean;
    url_maps: string;
    html_rodape: string;
    titulo_automatico: boolean;
    modelo_pagina_imovel: number;
    modelo_topo: number;
    modelo_cidades: number;
    modelo_busca: number;
    modelo_card: number;
    modelo_depoimento: number;
    modelo_selection: number;
    modelo_empresa: number;
    modelo_blogs: number;
    modelo_redes: number;
    modelo_fundo: number;
    modelo_pesquisa_popular: number;
    modelo_equipe: number;
    cards_busca: boolean;
    mostrar_data_entrega: boolean;
    afiliado_todo_site: boolean;
    categoria_home: boolean;
    caracteristicas_home: boolean;
    titulo_card_1: string;
    titulo_card_2: string;
    titulo_card_3: string;
    texto_card_1: string;
    texto_card_2: string;
    texto_card_3: string;
    depoimento_imovel: boolean;
    ver_url: boolean;
    banner_imovel: boolean;
    cidade_priorizada: string;
    texto_botao_whats?: string | null;
    formulario_whats: boolean;
    mostrar_mapa: boolean;
    exibir_empreendimento: boolean;
    moeda_tipo: string;
    simulador: boolean;
    ativa_logs: boolean;
    casa_em_condominio: boolean;
    carousel_temporada: boolean;
    carousel_apartamento: boolean;
    carousel_lancamentos: boolean;
    exibir_cidade_bairro_no_imovel: boolean;
    carousel_casa: boolean;
    carousel_novidades: boolean;
    titulo_c_top: string;
    titulo_c_temporada: string;
    titulo_c_novidades: string;
    titulo_c_casas: string;
    titulo_c_1: string;
    titulo_c_2: string;
    titulo_c_c_condominio: string;
    titulo_c_apartamentos: string;
    id: number;
    modelo_novo: string;
    ordenar_lista: string;
    mostrar_visualizacoes: boolean;
    site: string;
    titulo: string;
    meta_keywords: string;
    meta_description: string;
    url_logo: string;
    url_icon: string;
    url_video: string;
    rodape: number;
    texto_rodape: string;
    cor1: string;
    cor2: string;
    cor3: string;
    cor4: string;
    cor5: string;
    cor6: string;
    cor7: string;
    cor8: string;
    cor9: string;
    cor10: string;
    cor11: string;
    cor12: string;
    cor13: string;
    cor14: string;
    cor15: string;
    vgv_total: string
    total_imoveis: number
    total_cidades: number
    exibe_redes_sociais: boolean;
    congelado: boolean;
    qtd_fotos_bloqueios: number;
    bloquear_fotos: number;
    pixel_facebook_head: string;
    link_chat_body: string;
    link_chat_head: string;
    tag_google_head: string;
    tag_google_body: string;
    google_analytics_body: string;
    google_analytics_head: string;
    libera_fts_aluguel: string;
    banner_home?: string | null;
    carrossel_corretores: string;
    frase_busca: string;
    frase_busca_2: string;
    tamanho_logo: number;
    logo_horizontal: boolean;
    navbar_transparente: boolean;
    transacoes: string[];
    contador_marca: number;
    politica_privacidade: string;
    termos_uso: string;
    promocao: boolean;
    Dados: {
      inicio_txt_descricao: string;
      delegar_ao_agenciador?: boolean | null;
      horario: string;
      final_txt_descricao: string;
      empresa: string;
      email1: string;
      email2: string;
      email3?: string | null;
      email4?: string | null;
      tel1: string;
      tel2: string;
      tel3: string;
      tel4: string;
      tel1_nome: string;
      tel2_nome: string;
      tel3_nome: string;
      tel4_nome: string;
      tel1_whats: boolean;
      tel2_whats: boolean;
      tel3_whats: boolean;
      tel4_whats: boolean;
      endereco: string;
      cidade: string;
      bairro: string;
      creci: string;
      youtube: string;
      facebook: string;
      twitter: string;
      instagram: string;
      Linkedin: string;
      threads: string;
      tiktok: string;
    };
    video: boolean;
    widget_youtube: string;
    widget_instagram: string;
    marca_dagua: {
      opacidade: number;
      posicao: string;
      ativada: number;
      tamanho_marca: number;
    };
    exibir_agenciador: boolean;
  };
  videos: {
    url_youtube: string;
    excluido: boolean;
  }[];
   blogs: {
      id: number;
      url_foto: string;
      autor: string;
      titulo: string;
      texto: string;
      excluido: boolean;
      data_cadastro: string;
      id_cidade: number;
      id_empreendimento: number;
      categoria: string;
      id_categoria: number;
  }[];
  rodape: {
    tipo: string;
    cidade: string;
    bairro: string;
    dormitorios: string | null;
    aluguel: number;
    venda: number;
    empreendimento?: string | null;
  }[];
  allBanners: {
    id: number;
    codsite: number;
    exibir: string;
    ordem: number;
    extensao: string;
    titulo: string;
    url: string;
    url_link: string;
    message: string;
    ativo: boolean;
  }[];
  banner_empresa?: {
    linkbanner: string;
    card_titulo: string;
    subtitulo_1: string;
    paragrafo_1: string;
    subtitulo_2: string;
    paragrafo_2: string;
    subtitulo_3: string;
    paragrafo_3: string;
    corconfig: string;
  } | null;
  menus: {
    link: string;
    titulo: string;
    Destino: string;
    Disponivel: number;
    Menu: number;
    Rodape: number;
    Topo: number;
    Conteudo: string;
  }[];
  cidades: {
    id: number;
    nome: string;
    id_estado: number;
    url_foto: string;
  }[];
  tipos: {
    id: number;
    nome: string;
  }[];
  redes_sociais: {
      nome: string
      href: string
      imagem: string
      seguidores: string
      arroba: string
  }[];
  parceiros: {
    id: number;
    nome: string;
    contador_atualizacao: number;
    telefone: string;
    telefone_2?: string | null;
    email: string;
    mostrar_equipe: boolean;
    descricao?: string | null;
    funcao: {
      id: number;
      nome: string;
    } | null;
    url_foto: string;
    creci: string;
    link_proprio?: string | null;
    linkedin?: string | null;
    instagram?: string | null;
    facebook?: string | null;
  }[];
  depoimentos: {
    depoimento: string;
    youtube: string;
    cliente: {
      nome: string;
      foto?: string | null;
    };
  }[];
  precos_locacao: {
    min: number;
    max: number;
  }[];
  precos_venda: {
    min: number;
    max: number;
  }[];
  carrosseis: {
    id: number;
    id_bairro: number;
    id_tipo: number;
    id_categoria: number;
    id_cidade: number;
    id_caracteristica: number;
    id_empreendimento: number;
    preco_min: number;
    preco_max: number;
    titulo: String;
    top_10: Boolean;
    url_red: String;
    novidades_semana: Boolean;
    personalizado: Boolean;
    exclusivos: Boolean;
    venda: Boolean;
    aluguel: Boolean;
    cor_fundo: String;
    cor_degrade: String;
    cor_font: String;
    cor_botoes: String;
  }[];
}

export interface AuthContextType {
  allDataHome: AuthData | null;
  init_props: any;
  favorito: any;
  allViewProperties: any;
  allCompany: any;
  isMobile1: boolean;
  setFavorito: (_favs: any[]) => void;
  setAllViewProperties: (_value: any[]) => void;
  setAllCompany: (_value: any) => void;
  allCarrosseis: any;
  setAllCarrosseis: (_value: any) => void;
  setGetOnlyQuery1: (_value: any) => void;
  listCategory: any;
  getOnlyQuery1: any;
  all_cards_home: any;
  setListCategory: (_value: any) => void;
  listEstados: any;
  setListEstados: (_value: any) => void;
  listCaracteristicas: any;
  setListCaracteristicas: (_value: any) => void;
  listDatas: any;
  setListDatas: (_value: any) => void;
  include_favorito: (_imovel: any) => void;
  include_visualizado: (_imovel: any) => void;
  delete_favorito: (_imovel: any) => void;
  setUltimaConsulta: (_value: any) => void;
  ultimaConsulta: any;
  politic: null | 'accepted' | 'rejected' | 'nao';
  setPolitic: (_value: null | 'accepted' | 'rejected' | 'nao') => void;
}

/* ---------- CONTEXTO ---------- */
const AuthContext = createContext<AuthContextType | undefined>(undefined);

/* ---------- PROVIDER ---------- */
export const AuthProvider = ({
  children,
  init_props,
  allDataHome: allDataHomeProp,
}: Partial<AuthContextType> & { children: ReactNode }) => {
    const [favorito, setFavorito] = useState<Array<number>>([]);
    const [allViewProperties, setAllViewProperties] = useState<Array<number>>([]);
    const isMobile1 = init_props?.isMobile || isMobileDetect;

    const [allDataHome, setAllDataHome] = useState<AuthData | null>(allDataHomeProp || null);
    const [allCompany, setAllCompany] = useState(
        init_props?.all_company?.empreendimentos
        ? formatSelects(init_props?.all_company?.empreendimentos)
        : []
    );
    const [allCarrosseis, setAllCarrosseis] = useState(
        init_props?.all_carrosseis || []
    );
    const [getOnlyQuery1, setGetOnlyQuery1] = useState<any[]>([]);
    const [all_cards_home, setAll_cards_home] = useState<any[]>(init_props?.allCards);
    const [listCategory, setListCategory] = useState<any>(0);
    const [listEstados, setListEstados] = useState<any>(0);
    const [listCaracteristicas, setListCaracteristicas] = useState<any>(0);
    const [listDatas, setListDatas] = useState<any>(0);
    const [ultimaConsulta, setUltimaConsulta] = useState<any>('');
    const TTL1 = 60 * 30 * 1000; // 1 horas
    const [politic, setPoliticState] = useState<null | 'accepted' | 'rejected' | 'nao'>(null);
    const storageHost = useMemo(
      () =>
        init_props?.prodOrigin ||
        init_props?.origemInit ||
        allDataHomeProp?.site?.site ||
        allDataHome?.site?.site ||
        (typeof window !== 'undefined' ? window.location.host : ''),
      [allDataHome?.site?.site, allDataHomeProp?.site?.site, init_props?.origemInit, init_props?.prodOrigin]
    );
    const storageCodsite = useMemo(
      () => init_props?.codsite || allDataHomeProp?.site?.id || allDataHome?.site?.id || 0,
      [allDataHome?.site?.id, allDataHomeProp?.site?.id, init_props?.codsite]
    );
    const allDataHomeStorageKey = useMemo(
      () => getAllDataHomeStorageKey(storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const condosStorageKey = useMemo(
      () => getHomeScopedStorageKey('condominios', storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const cardsStorageKey = useMemo(
      () => getHomeScopedStorageKey('all_cards', storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );
    const lastSearchUrlStorageKey = useMemo(
      () => getImoveisLastSearchUrlStorageKey(storageHost, storageCodsite),
      [storageCodsite, storageHost]
    );

    useEffect(() => {
      if (!allDataHomeProp) return;
      setAllDataHome(allDataHomeProp as AuthData);
      setJsonStorageValue(localStorage, allDataHomeStorageKey, allDataHomeProp);
      localStorage.removeItem('allDataHome');
    }, [allDataHomeProp, allDataHomeStorageKey]);

    useEffect(() => {
      if (!Array.isArray(init_props?.all_carrosseis)) return;
      setAllCarrosseis(init_props.all_carrosseis);
    }, [init_props?.all_carrosseis]);
    
    // Mantem cookie e localStorage sincronizados para o SSR conseguir ler o consentimento.
    useEffect(() => {
        const cookieConsent = getMarketingConsentFromDocument();
        const storageConsent = getMarketingConsentFromLocalStorage();
        const resolvedConsent = resolveMarketingConsentState(cookieConsent, storageConsent);

        clearLegacyHomeStorageKeys(localStorage);
        setPoliticState(resolvedConsent);
        writeMarketingConsentLocalStorage(resolvedConsent);
        writeMarketingConsentCookie(resolvedConsent);

        const { favoritos } = router.query;
        if(favoritos){
            setFavorito(favoritos ? apenasNumeros(favoritos) : [])
        } else {
          const savedFavoritos = readJsonStorageValue<any[]>(localStorage, 'favoritos', []);
          if (savedFavoritos.length > 0) {
              setFavorito(savedFavoritos);
          }
        }
        const savedViews = readJsonStorageValue<any[]>(localStorage, 'allViewProperties', []);
        if (savedViews.length > 0) {
            setAllViewProperties(savedViews);
        }
    }, []);

    useEffect(() => {
        if(allCarrosseis?.length > 0){
          setWithTTL(
            getHomeScopedStorageKey(
              'all_carrosseis',
              storageHost,
              storageCodsite,
              allDataHome?.carrosseis?.length || 0
            ),
            allCarrosseis,
            TTL1
          );
        }
    }, [allCarrosseis, allDataHome?.carrosseis?.length, TTL1, storageCodsite, storageHost]);

    useEffect(() => {
        if(allDataHome?.site?.cards_busca == true && init_props?.allCards){
          setJsonStorageValue(localStorage, cardsStorageKey, init_props?.allCards);
          localStorage.removeItem('all_cards');
        } else {
          if(allDataHome?.site?.cards_busca == true){
            const allCardsCached = readJsonStorageValue<any[]>(localStorage, cardsStorageKey, []);
            if(allCardsCached.length > 0)
              setAll_cards_home(allCardsCached);
          }
        }
    }, [allDataHome?.site?.cards_busca, cardsStorageKey, init_props?.allCards]);

    // Salva o consentimento nos dois storages para manter compatibilidade cliente/SSR.
    const setPolitic = useCallback((_value: null | 'accepted' | 'rejected' | 'nao') => {
        setPoliticState(_value);
        writeMarketingConsentLocalStorage(_value);
        writeMarketingConsentCookie(_value);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('politic-change'));
        }
    }, [setPoliticState]);

    /* --------------------------------------------------
    * FAVORITOS
    * -------------------------------------------------- */
    useEffect(() => {
        if (favorito.length === 0) {
              localStorage.removeItem('favoritos');
        } else {
          setJsonStorageValue(localStorage, 'favoritos', favorito);
        }
    }, [favorito]);

    useEffect(() => {
        if (allViewProperties?.length == 0) {
          localStorage.removeItem('allViewProperties');
        } else {
          setJsonStorageValue(localStorage, 'allViewProperties', allViewProperties);
        }
    }, [allViewProperties]);

    /* --------------------------------------------------
    * ÚLTIMA CONSULTA + TTL
    * -------------------------------------------------- */
    useEffect(() => {
        if (ultimaConsulta) {
          setJsonStorageValue(localStorage, lastSearchUrlStorageKey, ultimaConsulta);
        } else {
          const ultima = readJsonStorageValue<string | null>(localStorage, lastSearchUrlStorageKey, null);
          if (typeof ultima === 'string' && ultima) {
              const ultimaProp = getWithTTL<any>(`ultima_consulta:${ultima}`);
              if (ultimaProp) setUltimaConsulta(ultima);
              else localStorage.removeItem(lastSearchUrlStorageKey);
          }
        }
    }, [lastSearchUrlStorageKey, ultimaConsulta]);

    /* --------------------------------------------------
    * FUNÇÃO PARA BUSCAR DADOS DO SITE
    * -------------------------------------------------- */

    /* --------------------------------------------------
    * CARREGA CONDOMÍNIOS / ALLDATAHOME
    * -------------------------------------------------- */
    useEffect(() => {
        if (allCompany.length === 0 && allDataHome?.site.exibir_empreendimento) {
        const timeout = setTimeout(() => {
            const cached = readJsonStorageValue<any>(localStorage, condosStorageKey, []);
            if (Array.isArray(cached) && cached.length > 0) {
              setAllCompany(cached);
              return;
            }
            if (cached?.empreendimentos?.length > 0) {
              setAllCompany(formatSelects(cached.empreendimentos));
            }
        }, 1000);
        return () => clearTimeout(timeout);
        } else if (allCompany.length > 0) {
        setJsonStorageValue(localStorage, condosStorageKey, allCompany);
        localStorage.removeItem('condominios');
        }

        if (allDataHome) {
          setJsonStorageValue(localStorage, allDataHomeStorageKey, allDataHome);
          localStorage.removeItem('allDataHome');
        } else {
          const cached = readJsonStorageValue<AuthData | null>(localStorage, allDataHomeStorageKey, null);
          if (cached) {
            setAllDataHome(cached);
          }
        }
    }, [allCompany, allDataHome, allDataHomeStorageKey, condosStorageKey]);

    /* --------------------------------------------------
    * FUNÇÕES DE FAVORITOS
    * -------------------------------------------------- */
    const include_favorito = useCallback((_imovel: any) => {
        setFavorito((prev) => prev.concat(_imovel));
    }, []);

    const include_visualizado = useCallback((_imovel: any) => {
      if(_imovel)
        setAllViewProperties((prev) => prev.concat(_imovel));
    }, []);

    const delete_favorito = useCallback((_imovel: any) => {
      setFavorito((prev) => {
        if(prev?.length <= 1)
          return [];
        else
          return prev.filter((id) => id !== _imovel);
      });
    }, []);

    /* --------------------------------------------------
    * CONTEXTO MEMOIZADO
    * -------------------------------------------------- */
    const ctxValue = useMemo<AuthContextType>(
        () => ({
            init_props: init_props || null,
            allDataHome: allDataHome || null,
            favorito,
            setAllViewProperties,
            allViewProperties,
            listCategory,
            ultimaConsulta,
            setListCategory,
            setUltimaConsulta,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            setAllCarrosseis,
            allCarrosseis,
            setGetOnlyQuery1,
            all_cards_home,
            getOnlyQuery1,
            allCompany,
            isMobile1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic
          }),
        [
            ultimaConsulta,
            setUltimaConsulta,
            init_props,
            isMobile1,
            setAllViewProperties,
            allViewProperties,
            allDataHome,
            allCompany,
            favorito,
            listCategory,
            setListCategory,
            listEstados,
            setListEstados,
            listCaracteristicas,
            setListCaracteristicas,
            listDatas,
            setListDatas,
            allCarrosseis,
            setAllCarrosseis,
            getOnlyQuery1,
            all_cards_home,
            setGetOnlyQuery1,
            setFavorito,
            setAllCompany,
            delete_favorito,
            include_favorito,
            include_visualizado,
            politic,
            setPolitic
        ]
    );

  return <AuthContext.Provider value={ctxValue}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
};
